import React from 'react';
import { Button } from '../ui/button';
import { useNavigate } from 'react-router-dom';
import { Sparkles } from 'lucide-react';

const CompletionStep = ({ data }) => {
  const navigate = useNavigate();

  const handleStartChat = () => {
    // Navigate to chat or home
    navigate('/chat');
  };

  const handleViewProfile = () => {
    // Show full unblurred profile
    navigate('/profile');
  };

  return (
    <div className="text-center flex flex-col items-center justify-center min-h-[80vh] px-4">
      {/* Blurred preview of AI girlfriend */}
      <div className="relative mb-8">
        <div className="w-64 h-80 rounded-2xl overflow-hidden relative bg-white/5 backdrop-blur-sm border border-white/10">
          {/* Placeholder avatar with blur */}
          <div className="w-full h-full bg-gradient-to-br from-[#F1B428]/20 to-[#1A1A1A] flex items-center justify-center">
            <div className="text-6xl">👤</div>
          </div>
          {/* Blur overlay */}
          <div className="absolute inset-0 backdrop-blur-2xl bg-black/30 flex items-center justify-center">
            <div className="bg-[#F1B428] px-6 py-3 rounded-full">
              <p className="text-black font-bold flex items-center gap-2">
                <Sparkles size={20} />
                Your AI Girlfriend
              </p>
            </div>
          </div>
        </div>
      </div>

      <h1 className="text-white text-3xl md:text-4xl font-bold mb-4">
        Your AI girlfriend is ready!
      </h1>
      
      <p className="text-white/70 text-base md:text-lg mb-8 max-w-md">
        Based on your preferences, we've created your perfect AI companion.
      </p>

      {/* Summary of selections */}
      <div className="bg-white/5 backdrop-blur-sm border border-white/10 rounded-2xl p-6 mb-8 max-w-md w-full">
        <div className="grid grid-cols-2 gap-4 text-left">
          <div>
            <p className="text-white/50 text-sm">Personality</p>
            <p className="text-white font-semibold capitalize">{data.personalityType || 'Not set'}</p>
          </div>
          <div>
            <p className="text-white/50 text-sm">Body Type</p>
            <p className="text-white font-semibold capitalize">{data.bodyType || 'Not set'}</p>
          </div>
          <div>
            <p className="text-white/50 text-sm">Age Range</p>
            <p className="text-white font-semibold">{data.age || 'Not set'}</p>
          </div>
          <div>
            <p className="text-white/50 text-sm">Attributes</p>
            <p className="text-[#F1B428] font-semibold">{data.personalityAttributes?.length || 0} selected</p>
          </div>
        </div>
      </div>

      <div className="space-y-4 w-full max-w-sm">
        <Button
          onClick={handleStartChat}
          className="w-full bg-[#F1B428] hover:bg-[#D9A022] text-black font-bold text-lg py-6 rounded-full transition-all duration-300 hover:scale-105 shadow-lg shadow-[#F1B428]/30"
        >
          Start Chatting
        </Button>
        
        <Button
          onClick={handleViewProfile}
          variant="outline"
          className="w-full bg-white/5 backdrop-blur-sm hover:bg-white/10 text-white font-semibold text-base py-5 rounded-full border-2 border-white/20 hover:border-[#F1B428]/50 transition-all duration-300 hover:scale-105"
        >
          View Full Profile
        </Button>
      </div>
    </div>
  );
};

export default CompletionStep;
